import React from 'react'
import { useStore } from 'zustand'

import { useSitePromotionPopupsStore } from './_core/hook'
import { useInitPopups } from './popups/inits'

import type { PromotionPopupBasicProps } from '@/contexts/SiteSpecificContext/popups/types'


import { useRef, useEffect } from 'react';
const TadAIPromotionModal = () => {
  const store = useSitePromotionPopupsStore()
  const onClose = useStore(store, (state) => state._onClose)
  const promotions = useStore(store, (state) => {
    return state.promotions
  })
  const openKey = useStore(store, (state) => state.openKey)

  useInitPopups()

  type PromotionPopupKey = keyof typeof promotions

  const promotionKeys = Object.keys(promotions) as Array<PromotionPopupKey>

  const mountedRef = useRef<PromotionPopupKey[]>([])

  useEffect(() => {
    if (openKey && !mountedRef.current.includes(openKey)) {
      mountedRef.current.push(openKey)
    }
  }, [openKey])

  return (
    <>
      {promotionKeys.map((key) => {
        const PopupComponent = promotions[key as PromotionPopupKey].component
        const open = key === openKey
        const openOrMounted = open || mountedRef.current.includes(key)

        if (!openOrMounted) {
          return null
        }

        const basicProps: PromotionPopupBasicProps = {
          open,
          onCancel: () => {
            onClose()
          },
        }
        return <PopupComponent key={key} {...basicProps} />
      })}
    </>
  )
}
export default TadAIPromotionModal
